/* eslint-disable */
export default {
  ringing: '수신 전화',
  callConnected: '통화 연결됨',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
